var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('app-loading',{staticClass:"fullscreen",attrs:{"is-loading":true,"spinner-color":'#1474a4'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }